import { render, staticRenderFns } from "./FdLink.vue?vue&type=template&id=9301a5b8&scoped=true&"
import script from "./FdLink.vue?vue&type=script&lang=js&"
export * from "./FdLink.vue?vue&type=script&lang=js&"
import style0 from "./FdLink.vue?vue&type=style&index=0&id=9301a5b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9301a5b8",
  null
  
)

export default component.exports